export interface OpenDropOffQrCodeTransactionInfo {
    trackingNumber: string;
    senderEmail: string;
    receiverEmail: string;
}

export type OpenDropOffQrCodePatternValidationResult =
    | { valid: true; pattern: RegExp }
    | { valid: false; reason: 'missing-pattern' | 'invalid-pattern' | 'missing-capture-groups' };

const REQUIRED_CAPTURE_GROUPS = ['trackingNumber', 'senderEmail', 'receiverEmail'] as const;

export const validateOpenDropOffQrCodePattern = (pattern: string | undefined): OpenDropOffQrCodePatternValidationResult => {
    if (!pattern?.trim()) return { valid: false, reason: 'missing-pattern' };

    try {
        const regex = new RegExp(pattern);
        const hasRequiredCaptureGroups = REQUIRED_CAPTURE_GROUPS.every((group) => pattern.includes(`(?<${group}>`));

        if (!hasRequiredCaptureGroups) return { valid: false, reason: 'missing-capture-groups' };

        return { valid: true, pattern: regex };
    } catch {
        return { valid: false, reason: 'invalid-pattern' };
    }
};

export const parseOpenDropOffQrCodeTransactionInfo = (
    qrCode: string,
    pattern: OpenDropOffQrCodePatternValidationResult
): OpenDropOffQrCodeTransactionInfo | null => {
    if (!pattern.valid) return null;

    const groups = pattern.pattern.exec(qrCode)?.groups;
    const trackingNumber = groups?.trackingNumber?.trim();
    const senderEmail = groups?.senderEmail?.trim();
    const receiverEmail = groups?.receiverEmail?.trim();

    if (!trackingNumber || !senderEmail || !receiverEmail) return null;

    return {
        trackingNumber,
        senderEmail,
        receiverEmail
    };
};
